<template>
    <section class="mod">
        <h2 class="mod-tit">历史南向资金</h2>
        <div class="nav-sub flex">
            <span
                v-for="(item, i) in ZJHistoryNavs"
                :key="i"
                :class="curZJHistory == i ? 'cur' : ''"
                @click="tableInfo(i)"
            >
                {{ item }}
            </span>
        </div>
        <div class="nav-sub-cont">
            <div class="chart-legent flex col2">
                <div
                    class="legent-more"
                    @click="showLineMore = !showLineMore"
                    :class="showLineMore ? 'down' : ''"
                >
                    <span class="legent-blue legent">{{
                        LineMoreArray[LineMoreIndex]
                    }}</span>
                    <ul v-show="showLineMore">
                        <li
                            v-for="(title, i) in LineMoreArray"
                            :class="LineMoreIndex == i ? 'actived' : ''"
                            :key="i"
                            @click="LineMoreIndex = i"
                        >
                            {{ title }}
                        </li>
                    </ul>
                </div>
                <div
                    class="legent-more"
                    @click="showKLMore = !showKLMore"
                    :class="showKLMore ? 'down' : ''"
                >
                    <span class="legent-kl legent">{{
                        KLMoreArray[KLMoreIndex]
                    }}</span>
                    <ul v-show="showKLMore">
                        <li
                            v-for="(title, i) in KLMoreArray"
                            :class="KLMoreIndex == i ? 'actived' : ''"
                            :key="i"
                            @click="zhishuInfo(i)"
                        >
                            {{ title }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="chart chart-history" id="kline"></div>
            <div class="chart-info flex">
                <div>
                    5{{ curZJHistory | formateDate }}净买<strong
                        :class="descInfo.amt5 | formateRedGreen"
                        >{{ descInfo.amt5 }}亿</strong
                    >
                </div>
                <div>
                    10{{ curZJHistory | formateDate }}净买<strong
                        :class="descInfo.amt10 | formateRedGreen"
                        >{{ descInfo.amt10 }}亿</strong
                    >
                </div>
                <div>
                    20{{ curZJHistory | formateDate }}净买<strong
                        :class="descInfo.amt20 | formateRedGreen"
                        >{{ descInfo.amt20 }}亿</strong
                    >
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// 获取南向资金 历史走势  跟  指数K线图
import { getNxzjCharts } from "@/api/lszx.js";
import { getUrlQuery } from "@/utils/handleUrl.js";
export default {
    name: "HistoryNorthAmount",
    data() {
        return {
            curZJHistory: 0,
            ZJHistoryNavs: ["按日", "按周", "按月"],
            showLineMore: false,
            LineMoreIndex: 0,
            LineMoreArray: ["南向累计净买"],
            showKLMore: false,
            KLMoreIndex: 0,
            KLMoreArray: ["上证指数", "深证成指", "创业板指", "沪深300"],
            token: "",
            obj: "SH000001",
            type: "1",
            dataInfo: [],
            descInfo: {},
        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        formateDate: function (v) {
            if (v == 0) {
                return "日";
            }
            if (v == 1) {
                return "周";
            }
            if (v == 2) {
                return "月";
            }
        },
    },
    mounted: function () {
        this.token = getUrlQuery("token");
        // this.drawKL();
        // 获取南向资金K线数据
        this.getNxzjData();
    },

    methods: {
        getNxzjData: function () {
            var _this = this;
            var params = {
                token: _this.token,
                obj: _this.obj,
                type: _this.type,
            };

            getNxzjCharts(params).then((res) => {
                console.log(res);
                if (res.data.err == 0) {
                    _this.dataInfo = res.data.data.data;
                    _this.descInfo = res.data.data.desc;
                    this.$nextTick(() => {
                        setTimeout(function () {
                            _this.drawKL();
                        }, 300);
                    });
                }
            });
        },

        drawKL: function () {
            var _this = this;

            var chartDom = document.getElementById("kline");
            var myChart = this.$echarts.init(chartDom);
            var option;
            // 数据意义：开盘、收盘、最低、最高、量

            var data = _this.dataInfo;
            var curZJHistory = this.curZJHistory;
            var starInfo = 95;
            if (curZJHistory == 0) {
                var starInfo = 95;
            } else if (curZJHistory == 1) {
                var starInfo = 75;
            } else {
                var starInfo = 0;
            }

            // var data = [
            //     ['2013/04/12',2218.09,2206.78,2204.44,2226.26,22.80,1688900],
            //     ['2013/04/15',2199.91,2181.94,2177.39,2204.99,88.90,2212900],
            // ];

            var dayObj = splitData(data);
            //拆分data为日期、数据、涨跌幅、量数组
            function splitData(rawData) {
                var categoryData = [];
                var values = [];
                var volumes = [];
                var closedValues = [];
                for (var i = 0; i < rawData.length; i++) {
                    categoryData.push(rawData[i].splice(0, 1));
                    var obj = {
                        value: 0,
                        itemStyle: {
                            normal: {
                                color: "#fd6761",
                                borderColor: "red",
                            },
                        },
                    };
                    obj.value = rawData[i][4];
                    // console.log(rawData[i])
                    // obj.itemStyle.normal.color =
                    //     rawData[i][0] > rawData[i][1] ? "#fd6761" : "#4dc174";
                    // obj.itemStyle.normal.borderColor =
                    //     rawData[i][0] > rawData[i][1] ? "#fd6761" : "#4dc174";
                    obj.itemStyle.normal.color =
                        rawData[i][4] >= 0 ? "#fd6761" : "#4dc174";
                    obj.itemStyle.normal.borderColor =
                        rawData[i][4] >= 0 ? "#fd6761" : "#4dc174";
                    volumes.push(obj);
                    values.push(rawData[i].splice(0, 4));
                    closedValues.push(rawData[i][1]);
                }
                return {
                    categoryData: categoryData,
                    volumes: volumes,
                    values: values,
                    closedValues: closedValues,
                };
            }
            option = {
                grid: [
                    // {
                    //     show: true,
                    //     left: 0,
                    //     right: 0,
                    //     top: 20,
                    //     bottom: 120,
                    //     borderWidth: 0,
                    // },
                    // {
                    //     show: true,
                    //     left: 0,
                    //     right: 0,
                    //     top: 230,
                    //     bottom: 0,
                    //     borderWidth: 0,
                    // },
                    {
                        show: true,
                        left: 0,
                        right: 0,
                        top: "10%",
                        // bottom: 120,
                        height: "50%",
                        borderWidth: 0,
                    },
                    {
                        show: true,
                        left: 0,
                        right: 0,
                        top: "80%",
                        bottom: 0,
                        height: "20%",
                        borderWidth: 0,
                    },
                ],
                axisPointer: {
                    link: { xAxisIndex: "all" },
                    lineStyle: {
                        color: "#666",
                        width: 1,
                    },
                },
                tooltip: {
                    trigger: "axis",
                    triggerOn: "click",
                    position: function (point) {
                        // 固定在底部
                        return [point[0] / 2, "10%"];
                    },
                    textStyle: {
                        fontSize: 12,
                        lineHeight: 22,
                    },
                    formatter: function (params) {
                        var date = params[0].name;
                        var kd = params[0].data;
                        var vo = params[2].value;
                        var leiji = params[1].value;
                        var rate, html;
                        if (kd.length) {
                            //判断是否是k线数组
                            rate = ((kd[1] - kd[2]) / kd[2]) * 100; //收盘价-开盘价/开盘价
                            console.log(params);
                            rate =
                                rate > 0
                                    ? "+" + rate.toFixed(2)
                                    : rate.toFixed(2);
                            html = `<div>${date}<br><span class='legent legent-kl'>上证指数：</span>${kd[1]} ${rate}%<br><span class='legent legent-blue'>南向累计净买(亿)：</span>${leiji}<br><span class='legent legent-blue'>南向净买(亿)：</span>${vo}</div>`;
                            return html;
                        } else {
                            kd = params[1].data;
                            vo = params[0].value;
                            rate = ((kd[1] - kd[2]) / kd[2]) * 100;
                            rate =
                                rate > 0
                                    ? "+" + rate.toFixed(2)
                                    : rate.toFixed(2);
                            html = `<div>${date}<br>上证指数：${kd[1]} ${rate}%<br>南向累计净买(亿)：${kd[2]}<br>南向净买(亿)：${vo}</div>`;
                            return html;
                        }
                    }.bind(this),
                },
                dataZoom: [
                    {
                        type: "inside",
                        xAxisIndex: [0, 1],
                        start: starInfo,
                        end: 100,
                        zoomLock: false,
                    },
                    {
                        type: "inside",
                        xAxisIndex: [0, 1],
                        start: starInfo,
                        end: 100,
                        zoomLock: false,
                    },
                ],
                xAxis: [
                    {
                        type: "category",
                        data: dayObj.categoryData,
                        position: "bottom",
                        boundaryGap: true,
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            show: true,
                            showMinLabel: true,
                            showMaxLabel: true,
                            color: "#999",
                            interval: data.length - 2,
                            formatter: function (value, index) {
                                //文本格式化
                                if (index === 0) {
                                    return "{right|" + value + "}";
                                } else if (index === data.length - 1) {
                                    return "{left|" + value + "}";
                                } else {
                                    return "{center|" + value + "}";
                                }
                            },
                            rich: {
                                right: {
                                    width: 100,
                                    fontSize: 10,
                                    align: "right",
                                },
                                left: {
                                    width: 100,
                                    fontSize: 10,
                                    align: "left",
                                },
                                center: {
                                    width: 100,
                                    fontSize: 10,
                                    align: "center",
                                    padding: [0, 0, 0, -60],
                                },
                            },
                        },
                    },
                    {
                        type: "category",
                        gridIndex: 1,
                        data: dayObj.categoryData,
                        boundaryGap: true,
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: { show: false },
                    },
                ],
                yAxis: [
                    {
                        // type: 'category',
                        scale: true,
                        splitNumber: 3,
                        splitLine: {
                            show: true,
                            interval: 2,
                            lineStyle: {
                                color: "#ccc",
                                type: "dashed",
                            },
                        },
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                        },
                        z: 5,
                    },
                    {
                        type: "value",
                        alignTicks: false,
                        position: "right",
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                        },
                        splitLine: { show: false },
                        min: function (value) {
                            return value.min;
                        },
                    },
                    {
                        scale: true,
                        splitNumber: 1,
                        gridIndex: 1,
                        splitLine: {
                            interval: 2,
                            lineStyle: { type: "dashed" },
                        },
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                return value;
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "日K",
                        type: "candlestick",
                        barWidth: "60%",
                        itemStyle: {
                            normal: {
                                color: "#4dc174",
                                color0: "#fd6761",
                                borderColor: "#4dc174",
                                borderColor0: "#fd6761",
                            },
                            emphasis: {
                                borderWidth: 1,
                            },
                        },
                        data: dayObj.values,
                    },
                    {
                        name: "量",
                        type: "bar",
                        barWidth: "60%",
                        xAxisIndex: 1,
                        yAxisIndex: 2,
                        data: dayObj.volumes,
                    },
                    {
                        name: "日收盘价",
                        type: "line",
                        data: dayObj.closedValues,
                        smooth: true,
                        z: 0,
                        yAxisIndex: 1,
                        itemStyle: {
                            normal: {
                                opacity: 0,
                            },
                        },
                        areaStyle: {
                            color: this.$echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        // 1代表上面
                                        offset: 0,
                                        color: "rgba(92,147,249,0.3)",
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(255,255,255,0)",
                                    },
                                ]
                            ),
                            global: false, // 缺省为 false
                        },
                        lineStyle: {
                            normal: {
                                color: "#5c93f9",
                                width: 1,
                                opacity: 1,
                            },
                        },
                    },
                ],
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        tableInfo: function (i) {
            this.curZJHistory = i;
            if (i == 0) {
                this.type = 1;
            } else if (i == 1) {
                this.type = 2;
            } else {
                this.type = 3;
            }
            this.getNxzjData();
        },
        zhishuInfo: function (i) {
            this.KLMoreIndex = i;
            if (i == 0) {
                // 上证
                this.obj = "SH000001";
            } else if (i == 1) {
                // 深证
                this.obj = "SZ399001";
            } else if (i == 2) {
                //创业板指
                this.obj = "SZ399006";
            } else {
                this.obj = "SH000300";
            }
            this.getNxzjData();
        },
    },
};
</script>
